import { useFieldArray } from 'react-hook-form'
import { createContext } from '@chakra-ui/react-utils'

const [FormFieldArrayProvider, useFormFieldArrayContext] = createContext({
  strict: false,
  name: 'FormFieldArrayContext',
  errorMessage:
    'useFormFieldArrayContext: `context` is undefined. Seems you forgot to wrap the components in `<FormFieldArray />`'
})

export const useFormFieldArray = ({ name, keyName = 'key', ...rest }) => {
  const context = useFieldArray({ name, keyName, ...rest })
  return {
    ...context,
    name
  }
}

export const useFormFieldArrayItem = () => {
  const context = useFormFieldArrayContext()

  return context
}

export { FormFieldArrayProvider, useFormFieldArrayContext }
